<div class="container">
  <form [formGroup]="filterForm">
    <div class="form-row">
      <div class="col-md-4 mb-3">
        <label for="startDate" [dir]="languageService.getDir()">From</label>
        <div class="input-group">
          <input type="text" id="startDate" name="startDate" class="form-control" placeholder="dd.mm.yyyy"
                 ngbDatepicker #sd="ngbDatepicker" firstDayOfWeek="0" [dir]="languageService.getDir()"
                 formControlName="startDate">
          <button class="btn btn-outline-secondary calendar" (click)="sd.toggle()" type="button">
            <i class="fas fa-calendar"></i>
          </button>
        </div>
      </div>
      <div class="col-md-4 mb-3">
        <label for="endDate" [dir]="languageService.getDir()">To</label>
        <div class="input-group">
          <input type="text" id="endDate" name="endDate" class="form-control" placeholder="dd.mm.yyyy"
                 ngbDatepicker #ed="ngbDatepicker" firstDayOfWeek="0" [dir]="languageService.getDir()"
                 formControlName="endDate">
          <button class="btn btn-outline-secondary calendar" (click)="ed.toggle()" type="button">
            <i class="fas fa-calendar"></i>
          </button>
        </div>
      </div>
      <div class="col-md-4 mb-3">
        <label for="visitorStatus" [dir]="languageService.getDir()">Status</label>
        <select id="visitorStatus" class="form-control" formControlName="visitorStatus">
          <option value="ALL" selected>ALL</option>
          <option *ngFor="let status of visitorStatusKeys" [value]="status">{{ visitorStatuses[status] }}</option>
        </select>
      </div>
    </div>
  </form>
  <div class="user-list mt-3 mb-3 table-responsive" *ngIf="visitors.length > 0">
    <table class="table table-striped table-responsive-lg">
      <thead>
      <tr>
        <th scope="col" class="text-center">#</th>
        <th scope="col" class="text-center">First Name</th>
        <th scope="col" class="text-center">Last Name</th>
        <th scope="col" class="text-center">Phone</th>
        <th scope="col" class="text-center">Email</th>
        <th scope="col" class="text-center">Order Status</th>
        <th scope="col" class="text-center">Order Start</th>
        <th scope="col" class="text-center">Order End</th>
        <th scope="col" class="text-center">Work places</th>
        <!--        <th scope="col" class="text-center"></th>-->
        <!--        <th scope="col" class="text-center"></th>-->
        <!--        <th scope="col" class="text-center"></th>-->
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let visitor of visitors | paginate : {
                  itemsPerPage: pageSize,
                  currentPage: pageNumber,
                  totalItems: totalElements
                };
          let i = index">
        <th scope="row">{{ visitor.id }}</th>
        <td class="text-center">{{ visitor.firstname }}</td>
        <td class="text-center">{{ visitor.lastname }}</td>
        <td class="text-center">{{ visitor.phone }}</td>
        <td class="text-center">{{ visitor.email }}</td>
        <td class="text-center">{{ visitor.visitorStatus }}</td>
        <td class="text-center">{{ visitor.start | date:'dd.MM.yy HH:mm' }}</td>
        <td class="text-center">{{ visitor.end | date:'dd.MM.yy HH:mm' }}</td>
        <td class="text-center">{{ visitor.order.workPlaces }}</td>
        <td class="text-center" *ngIf="visitor.visitorStatus !== 'INACTIVE'">
          <button (click)="updateVisitor(visitor)">Update</button>
          <button (click)="deleteVisitor(visitor.id)">Delete</button>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
  <div *ngIf="totalElements > 0" class="row justify-content-center">
    <div class="col-md-auto">
      <pagination-controls
        previousLabel="Prev"
        nextLabel="Next"
        responsive="true"
        (pageChange)="handlePageChange($event)"></pagination-controls>
    </div>
    <div class="col-md-auto">
      Items per page:
      <select (change)="handlePageSizeChange($event)">
        <option *ngFor="let size of pageSizes" [ngValue]="size">
          {{ size }}
        </option>
      </select>
    </div>
    <div class="col-md-auto">
      <div>{{ getMinLimit() }}-{{ getMaxLimit() }} of {{ totalElements }} items</div>
    </div>
  </div>
  <div *ngIf="visitors.length == 0">
    <strong>You don't have visitors yet.</strong>
  </div>
  <div class="text-center">
    <button type="button" class="btn btn-default add-button" (click)="openAddVisitorModal()">
      <i class="fas fa-plus"></i> Add new
    </button>
  </div>
</div>
